export default __webpack_public_path__ + "static/media/MONT-BLANC-SEMIBOLD.7095197c.OTF";